// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SharedWebAddressUpsearchModel {
    static getAttributeTypeMap() {
        return SharedWebAddressUpsearchModel.attributeTypeMap;
    }
}
SharedWebAddressUpsearchModel.discriminator = undefined;
SharedWebAddressUpsearchModel.additionalProperties = false;
SharedWebAddressUpsearchModel.attributeTypeMap = [
    {
        "name": "webAddressId",
        "baseName": "webAddressId",
        "type": "number"
    },
    {
        "name": "webAddressType",
        "baseName": "webAddressType",
        "type": "ContactInfoPurposeType"
    },
    {
        "name": "url",
        "baseName": "url",
        "type": "string"
    },
];
//# sourceMappingURL=sharedWebAddressUpsearchModel.js.map